import React, { Fragment } from 'react';

import { ColorBox } from '../../Components'
import { history } from '../../Helpers';

export const MediaBoxRow = props => {
    const { href, imageSrc, title, description } = props;

    const go = () => {
        if (!href)
            return;

        history.push(href);
    }

    return (
        <div className={`media text-muted pt-3` + (href && href.length > 0 ? " pointer" : "")} onClick={go}>
            <ColorBox imageSrc={imageSrc}></ColorBox>
            <div className="media-body pb-3 mb-0 lh-125 border-bottom border-gray">
                <strong className="d-block text-dark">{title}</strong>
                {description && 
                    <ul className="list-inline mb-0">
                        {description.map((d, dIndex) => { 
                            return (
                                <Fragment key={dIndex}>
                                    {dIndex > 0 && <li className="list-inline-item">&middot;</li>}
                                    <li className="list-inline-item">{d}</li>
                                </Fragment>)
                        })}
                    </ul>
                }
            </div>
        </div>
    );
}